import {Component, Inject, Input} from 'ng-metadata/core';
import {getLibraryLogo} from '../../../appConfig/customizationConfig';
import {getLibraryLogoClickableURL} from '../../../appConfig/customizationConfig';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {getVid, getAttributesMap,getUrlContext} from '../../../appConfig/appConfigForward';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';

@Component({
    "selector": "prm-logo",
    templateUrl: 'components/search/topbar/logo/logo.html',
})
export class PrmLogo {

    private iconLink: Object;
    private logoURL: Object;
    private vid: string = getVid();
    private disableLogo: boolean = false;
    private needSref: boolean;
    @Input() public displayMode: string;

    constructor(@Inject('$state') private $state: angular.ui.IStateService,
                private configurationUtil: ConfigurationUtil) {
        this.getLogoIcon();
        this.setLogoURL();
        if ((this.$state.current.name === 'deposit' || this.$state.current.name === 'delivery' || this.$state.current.name === 'canonDelivery' || this.$state.current.name === 'cnameDelivery')
                &&!getLibraryLogoClickableURL() && !this.$state.params.vid.endsWith(":ResearchRepository")) {
            this.disableLogo = true;
        }
        
        if(!this.disableLogo){
			try {
				let imageOgTag = <HTMLMetaElement>document.getElementById("ogImage");
				if(this.iconLink.startsWith('http')){
					imageOgTag.content=this.iconLink;
				}else{
					imageOgTag.content=window.location.origin+'/'+getUrlContext()+'/'+this.iconLink;
				}
			}catch (e) {
				console.log("Not exists meta element description in index");
			}        	
        }
    }

    getLogoIcon() {
        this.iconLink = getLibraryLogo() || 'img/library-logo.png';
    }

    public setLogoURL() {
        let libraryLogoClickableURL = getLibraryLogoClickableURL();
        if (libraryLogoClickableURL) {
            this.logoURL = libraryLogoClickableURL;
        } else {//if there is no LogoClickableURL...
            if (this.configurationUtil.getSummonOverAlma() === true) {
                this.logoURL = getAttributesMap().sessionTimeoutURL;
            } else {
                this.needSref = true;
            }
        }

    }

    public isEmailMode() {
        return this.displayMode === 'email';
    }

}





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/logo/logo.directive.ts